<template>
  <div class="flex flex-wrap gap-4 text-center">

    <!-- youtube -->

    <div v-if="!shopZone.disabledFeatures.includes('YOUTUBE_PLUGIN')" class="w-full flex flex-col gap-4 px-4 py-8 bg-neutral-50 desktop:flex-1">
      <AtomsImagesIcon icon="youtube" size="xl" />
      <div>{{ $t('Představení produktů, recenze, srovnání ... Měsíčně přidáme 20 až 30 videí.') }}</div>
      <div class="grid gap-4 my-8 tablet:grid-cols-2">
        <div class="flex-col" :class="{ 'hidden tablet:flex': index >= 3, 'flex': index < 2 }" v-for="(video, index) in videos">
          <AtomsContainersCornerBorders :size="1" class="relative flex items-center aspect-video overflow-hidden">
            <MoleculesBlocksVideoItem :title="video.title" :youtube-id="video.youtubeId" :thumbnails="video.thumbnails" :is-our-channel="video.isOurChannel" class="absolute w-full" />
          </AtomsContainersCornerBorders>
          <div class="flex-1 mt-2 p-4 text-xs uppercase font-bold text-left text-neutral-50 bg-neutral-500">
            {{ video.title }}
          </div>
        </div>
      </div>
      <MoleculesButtonsButton class="mt-auto mx-auto" :href="appConfig.externalLinks.youtube" :arrow-right="true" target="_blank" link-rel="nofollow">{{ $t('Všechna videa na YouTube') }}</MoleculesButtonsButton>
    </div>

    <!-- instagram -->

    <div v-if="!shopZone.disabledFeatures.includes('INSTAGRAM_PLUGIN')" class="w-full flex flex-col gap-4 px-4 py-8 bg-neutral-50 desktop:flex-1">
      <AtomsImagesIcon icon="instagram" size="xl" />
      <div>{{ $t('Fotky z natáčení, střelnice i přírody. Obrázek vydá za tisíce slov.') }}</div>
      <div class="grid grid-cols-2 gap-4 my-8">
        <template v-for="photo in instagramPhotos.filter(photo => photo.mediaType === 'IMAGE' || photo.mediaType === 'CAROUSEL_ALBUM').slice(0, 6)">
          <AtomsTextLink :href="photo.permalink" target="_blank" class="overflow-hidden">
            <img :src="photo.mediaUrl" :alt="photo.caption" :title="photo.caption" class="aspect-square transition-all duration-300 hover:scale-[1.05]" />
          </AtomsTextLink>
        </template>
      </div>
      <MoleculesButtonsButton class="mt-auto mx-auto" :href="shopZone.externalLinks?.instagram ?? appConfig.externalLinks.instagram" :arrow-right="true" target="_blank" link-rel="nofollow">{{ $t('Prohlédnout Instagram') }}</MoleculesButtonsButton>
    </div>

    <!-- facebook -->

    <div class="w-full flex flex-col gap-4 px-4 py-8 bg-neutral-50 desktop:flex-1">
      <AtomsImagesIcon icon="facebook" size="xl" />
      <div>{{ $t('Novinky z našeho obchodu, důležité informace k e-shopu i kamenným prodejnám.') }}</div>
      <div class="my-8" v-if="useConsent().hasConsent(4)">
        <iframe class="tablet:hidden mx-auto" :src="`https://www.facebook.com/plugins/page.php?href=${shopZone.externalLinks?.facebookPlugin ?? 'https%3A%2F%2Fwww.facebook.com%2Frigadgear'}&tabs=timeline&width=300&height=730&small_header=true&adapt_container_width=false&hide_cover=true&show_facepile=true&appId=125883084092512`" height="730" style="border: none; overflow: hidden" scrolling="no" frameborder="0" allowfullscreen="true" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"></iframe>
        <iframe class="hidden w-[400px] tablet:block mx-auto" :src="`https://www.facebook.com/plugins/page.php?href=${shopZone.externalLinks?.facebookPlugin ?? 'https%3A%2F%2Fwww.facebook.com%2Frigadgear'}&tabs=timeline&width=400&height=730&small_header=true&adapt_container_width=false&hide_cover=true&show_facepile=true&appId=125883084092512`" height="730" style="border: none; overflow: hidden" scrolling="no" frameborder="0" allowfullscreen="true" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"></iframe>
      </div>
      <div v-if="!useConsent().hasConsent(4)" class="my-8">
        <div class="max-w-[300px] mx-auto my-8 font-bold text-xl">{{ $t('Pro zobrazení obsahu je nutné udělit souhlas s personalizovanými cookies.') }}</div>
        <MoleculesButtonsButton v-if="useCookie('cookieConsent').value != null" @click="useState('cookieConsentVisible', () => false).value = true" :arrow-right="true" :ghost="true">{{ $t('Otevřít nastavení cookies') }}</MoleculesButtonsButton>
      </div>
      <MoleculesButtonsButton class="mt-auto mx-auto" :href="shopZone.externalLinks?.facebook ?? appConfig.externalLinks.facebook" :arrow-right="true" target="_blank" link-rel="nofollow">{{ $t('Prohlédnout Facebook') }}</MoleculesButtonsButton>
    </div>

  </div>
</template>

<script setup>

const appConfig = useAppConfig();
const locale = useLocale().getLocale();
const shopZone = useShopZone().value;

const videos = (await useApiFetch(`/api/videosDefault?currencyId=${locale.currencyId}&languageId=${locale.languageId}`)).youtubeVideoList.youtubeVideos.items;

let instagramPhotos = [];

if (!useRequestURL().hostname.includes('.local')) {
  instagramPhotos = (await useApiFetch(`/api/instagramPhotos`)).external.instagram.widget;
}

</script>